import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const UpsellDeleteModal = ({ open, onClose, onConfirm, upsellToDelete }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className="delete-upsell-modal"
    >
      <div className="delete-upsell-modal-title">
        <h2>Delete this Upsell?</h2>
        <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
      </div>

      <DialogContent className="delete-upsell-modal-content">
        <Typography>
          Are you sure you want to delete this upsell? This action cannot be
          undone and the upsell will no longer be available to users.
        </Typography>
      </DialogContent>
      <DialogActions className="delete-upsell-modal-actions">
        <Button onClick={onClose} color="#fff" variant="contained">
          Never mind
        </Button>
        <Button
          onClick={() => onConfirm(upsellToDelete)}
          color="secondary"
          variant="contained"
        >
          Yes, Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpsellDeleteModal;
